import { ShippingOption } from '@medusajs/medusa'

import { ListShippingMethodsByCartIdDto } from '../dtos/shipping-options.dto'
import { CheckoutRepository } from '../repositories/checkout'
import { ListShippingMethodsByCartIdSchema } from '../schemas/list-shipping-methods-by-cart-id.schema'

type InjectedDependencies = {
    checkoutRepository: CheckoutRepository
}

export class CheckoutService {
    private readonly _checkoutRepository: CheckoutRepository

    constructor({ checkoutRepository }: InjectedDependencies) {
        this._checkoutRepository = checkoutRepository
    }

    public async getAllDeliveryOptions(): Promise<ShippingOption[]> {
        return await this._checkoutRepository.getAllDeliveryOptions()
    }

    public async getAllPaymentMethods() {
        return await this._checkoutRepository.getAllPaymentMethods()
    }

    public async listShippingMethodsByCartId(
        dto: ListShippingMethodsByCartIdDto,
    ): Promise<ShippingOption[]> {
        const validatedDto =
            await ListShippingMethodsByCartIdSchema.safeParseAsync(dto)

        if (!validatedDto.success) {
            throw new Error('Invalid cart_id while listing shipping methods')
        }

        return await this._checkoutRepository.listShippingMethodsByCartId(
            validatedDto.data,
        )
    }
}
